import CompanyDevicesTab from 'src/components/pages/Company/CompanyPage/CompanyDevicesTab/CompanyDevicesTab';

export default CompanyDevicesTab;
